import type { AppProps } from "next/app";
import "@/styles/globals.css";
import GlobalDebugHUD from "@/components/GlobalDebugHUD";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <GlobalDebugHUD />
      <Component {...pageProps} />
    </>
  );
}
